/**
 * datatables-datetime-moment - Sort date and time in any format using Moment.js
 * @version v1.10.13
 * @author Allan Jardine <b@rubble.com> (https://datatables.net/)
 * @link https://datatables.net/
 * @maintainers
 *  Matteo Gaggiano <maxxxx92@gmail.com> (https://marchrius.org)
 * @license MIT
 */
!function(e){"function"==typeof define&&define.amd?define(["jquery","moment","datatables.net"],e):e(jQuery,moment)}(function(e,n){e.fn.dataTable.moment=function(t,r){var a=e.fn.dataTable.ext.type;a.detect.unshift(function(a){return a&&(a.replace&&(a=a.replace(/(<.*?>)|(\r?\n|\r)/g,"")),a=e.trim(a)),""===a||null===a?"moment-"+t:n(a,t,r,!0).isValid()?"moment-"+t:null}),a.order["moment-"+t+"-pre"]=function(a){return a&&(a.replace&&(a=a.replace(/(<.*?>)|(\r?\n|\r)/g,"")),a=e.trim(a)),""===a||null===a?-(1/0):parseInt(n(a,t,r,!0).format("x"),10)}}});